module.exports = __webpack_public_path__ + "img/id-qtv-1.b0918534.webp";